import styled from 'styled-components';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';

export const SelectedPlanActionMenuButton = styled(IconButton).attrs({
  variant: 'secondary',
  icon: 'far fa-cog',
  'aria-label': 'Financial plan menu',
})(({ theme }) => ({
  height: 64,
  width: 67,
  borderRadius: `0 0 ${theme.radii.medium}px 0`,
}));
